/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import React from "react";
import Globals from "../../shared/Globals";
import { qreq } from "../../shared/qrequest";
import BaseCom from "../BaseCom";
import Card from "../Card";
import Editable from "../Editable";
import Icon from "../Icon";
import Tick from "../Tick";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import FormInput from "../FormInput";
import DiagCodeSelectModal from "../DiagCodeSelectModal";



class ClaimItemTable extends BaseCom {
    Scope = {}

    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
    }

    async componentDidMount() {
        this.id = this.props.id;
        this.tableRef.current.setAttribute('data-id', this.props.id);
        await this.fillListAsync('/api/modcode/list', 'modCodes', true);
        document.addEventListener('mouseup', this.dragFinish);
        document.addEventListener('mousemove', this.trackMousePosition)
    }

    componentWillUnmount() {
        document.removeEventListener('mouseup', this.dragFinish);
        document.removeEventListener('mousemove', this.trackMousePosition);
    }

    toggleAddMod = (i) => {
        i.add = !i.add;
        this.props.onToggle?.();
    }

    addModCode = (e, i) => {
        let find = i.modifiers?.find(j => j.id === parseInt(e.target.value));
        if (find) {
            i.add = false;
            this.props.onToggle?.();
            return; // already added
        }
        let mod = this.state.modCodes.find(j => j.id === parseInt(e.target.value));
        if (mod) {
            i.modifiers = i.modifiers ?? [];
            i.modifiers.push(mod);
            i.add = false;
            this.props.onToggle?.();
        }
    }

    removeModCode = (i, j) => {
        i.modifiers = i.modifiers.filter(a => a.id !== j.id);
        this.props.onToggle?.();
    }

    toggleAddDiagCode = (i) => {
        i.addDiagCode = !i.addDiagCode;
        this.props.onToggle?.();
    }

    addDiagCode = (e, i) => {
        if(e.target.value === 'OTHER') {
            this.setState({ showDiagCodeSelect: true, selectedItem: i });
            return;
        }
        let find = i.diagCodes?.find(j => j.id === parseInt(e.target.value));
        if (find) {
            i.addDiagCode = false;
            this.props.onToggle?.();
            return; // already added
        }
        let diag = this.props.diagCodes.find(j => j.id === parseInt(e.target.value));
        if (diag) {
            i.diagCodes = i.diagCodes ?? [];
            i.diagCodes.push(diag);
            i.addDiagCode = false;
            this.props.onToggle?.();
        }
    }
    
    selectOtherDiagCode = (dc) => {
        let i = this.state.selectedItem;

        let diag = this.props.diagCodes.find(j => j.id === parseInt(dc.id));

        if(!diag) {
            this.props.diagCodes.push(dc);
            diag = dc;
        }

        i.diagCodes = i.diagCodes ?? [];
        i.diagCodes.push(diag);
        i.addDiagCode = false;
        this.setState({ showDiagCodeSelect: false });
        this.props.onToggle?.();
    }

    removeDiagCode = (i, j) => {
        i.diagCodes = i.diagCodes.filter(a => a.id !== j.id);
        this.props.onToggle?.();
    }

    applyField = (item, field, v) => {
        item[field] = v;
        if(field === 'fee' || field === 'units') {
            item.charge = item.fee * item.units;
        }
        this.props.onToggle?.();
    }


    applyCode = async (item, v) => {
        item.code = v;
        item._editCode = false;
        this.props.onToggle?.();
        try {
            let j = await qreq.getAsync('/api/claim/code/' + item.code);
            if (j.item) {
                item.fee = j.item.price;
                item._closeDescription = false;
                if(j.item.productName)
                    item.name = j.item.name;
                else
                    item.name = j.item.description;
                item.charge = item.fee * item.units;
            }
        }
        catch (e) {
            console.error(e);
        }
        this.props.onToggle?.();
    }

    getTotal = () => {
        let total = 0;
        this.props.list?.forEach(i => {
            if(!isNaN(i.charge))
                total += i.charge;
        });
        return total;
    }

    getTotalUnits = () => {
        let total = 0;
        this.props.list?.forEach(i => {
            if(!isNaN(i.units))
                total += i.units;
        });
        return total;
    }

    dragBegin = (e, item) => {
        e.preventDefault();
        console.log('dragBegin', e);
        document.body.style.cursor = 'move';
        let tbody = e.target.closest('tbody');
        let table = tbody.closest('table');
        if(tbody) {
            tbody.classList.add('dragging');
            this.Scope.CurrentDrag = {
                id: this.id,
                item: item,
                tbody: tbody,
                table: table
            };
        }
    }

    dragFinish = (e) => {
        console.log('dragFinish', e);
        if(!this.Scope.CurrentDrag)
            return;
        if(this.Scope.CurrentDrag.drop) {
            this.props.transfer(this.Scope.CurrentDrag.item, this.Scope.CurrentDrag.dropTableID, this.id);
        }
        document.body.style.cursor = 'default';
        this.Scope.CurrentDrag?.tbody?.classList?.remove('dragging');
        this.Scope.CurrentDrag?.drop?.classList?.remove('dropping');
        this.Scope.CurrentDrag?.clone?.remove();
        this.Scope.CurrentDrag = null;
    }

    trackMousePosition = (e) => {
        this.mouseX = e.clientX;
        this.mouseY = e.clientY;
    }

    getDragClone(tr) {
        let clone = this.Scope.CurrentDrag.clone;
        if(!clone)
            clone = tr.cloneNode(true);
        else
            clone.remove();
        return clone;
    }

    tick = () => {
        if(this.Scope.CurrentDrag) {
            if(this.Scope.CurrentDrag.id !== this.id)
                return;
            let tbody = this.Scope.CurrentDrag.tbody;
            let hovering = document.elementFromPoint(this.mouseX, this.mouseY);
            let ele = this.getParentElementWithClass(hovering, '__claim_item');
            /*
            // Enable when reordering is integrated

            if(ele && ele.hasAttribute('master-id')) {
                let masterID = ele.getAttribute('master-id');
                if(this.Scope.CurrentDrag.item.masterID === masterID) {
                    return;
                }
                let clone = this.getDragClone(tbody);
                ele.parentNode.prepend(clone);
                this.Scope.CurrentDrag.clone = clone;
            }
            else {
            */
                ele = this.getParentElementWithClass(hovering, '__claim_table');

                if(ele) {
                    if(this.Scope.CurrentDrag.drop && this.Scope.CurrentDrag.drop !== ele) {
                        this.Scope.CurrentDrag.drop.classList.remove('dropping');
                        this.Scope.CurrentDrag.drop = null;
                    }
                    let tableID = ele.getAttribute('data-id');
                    if(tableID !== this.props.id)
                        ele.classList.add('dropping');
                    this.Scope.CurrentDrag.drop = ele;
                    this.Scope.CurrentDrag.dropTableID = tableID;
                }
                else {
                    if(this.Scope.CurrentDrag.drop) {
                        this.Scope.CurrentDrag.drop.classList.remove('dropping');
                        this.Scope.CurrentDrag.drop = null;
                    }
                }

                if(this.Scope.CurrentDrag.clone) {
                    this.Scope.CurrentDrag.clone.remove();
                    this.Scope.CurrentDrag.clone = null;
                }
            //}
        }
    }

    split = (item) => {
        let units = item.units;
        if(units > 1) {
            units = Math.floor(units / 2);
        }
        let newItem = {
            uuid: this.uuid(),
            claimID: item.claimID,
            productID: item.productID,
            cptCodeID: item.cptCodeID,
            name: item.name,
            code: item.code,
            fee: item.fee,
            modifiers: item.modifiers,
            diagCodes: item.diagCodes,
            description: item.description,
            serviceDate: item.serviceDate,
            placeOfServiceCode: item.placeOfServiceCode,
            unitsMeasure: item.unitsMeasure,
        };
        newItem.units = units;
        newItem.charge = item.fee * units;
        item.units -= units;
        item.charge = item.fee * item.units;
        this.props.onAdd?.(newItem);
    }

    render() {
        return (
            <>
            <DiagCodeSelectModal
                show={this.state.showDiagCodeSelect}
                onHide={() => this.setState({ showDiagCodeSelect: false })}
                onChange={this.selectOtherDiagCode}
                />
            <Card
                title={this.props.title}
                headerButtons={this.props.onRemoveChild && <button type="button" className="btn btn-danger" onClick={this.props.onRemoveChild}><Icon icon="faTrash" /> Remove</button>}
            >
                <Tick onTick={this.tick} interval={200} />
                <table className="table table-striped __claim_table" ref={this.tableRef}>
                    <thead>
                        <tr>
                            <th></th>
                            <th>Code</th>
                            <th style={{width: '30%'}}>Description</th>
                            <th>Modifiers</th>
                            <th>Diag Codes</th>
                            <th>Fee</th>
                            <th>Units</th>
                            <th>Charge</th>
                            <th></th>
                        </tr>
                    </thead>
                    {this.props.list?.map((i, idx) => (
                        <tbody key={idx} className={'__claim_item' + (i._loading ? ' _loading' : '')} master-id={i.masterID}>

                            <tr>
                                <td className="move" onMouseDown={(e) => this.dragBegin(e,i)} onMouseUp={this.dragFinish}>
                                    <Icon icon="faGrip" className="fs-5 text-muted" />
                                </td>
                                <td>
                                    <Editable value={i.code} onChange={(v) => this.applyCode(i, v)} disabled={this.props.disabled} />
                                </td>
                                <td>
                                    <Editable value={i.name} onChange={(v) => this.applyField(i, 'name', v)} disabled={this.props.disabled} />
                                </td>
                                <td>
                                    <span>
                                        {i.modifiers?.length === 0 && !i.add && <span className="text-muted">None</span>}
                                        {i.modifiers?.map((j, jdx) => (
                                            <span key={jdx} className="badge bg-secondary me-1 mb-1 no-select" title={j.description} data-tooltip-content={j.description}>
                                                {j.code} <Icon icon="faTimes" role="button" onClick={() => this.removeModCode(i, j)} />
                                            </span>
                                        ))}
                                    </span>
                                    {i.add && <div className="input-group">
                                        <select className="form-select" onChange={(e) => this.addModCode(e, i)}>
                                            <option value="">Select Modifier</option>
                                            {this.state.modCodes?.map((j, jdx) => !i.modifiers?.find(a => a.id === j.id)
                                                && <option key={jdx} value={j.id}>{j.code} - {j.description}</option>)}
                                        </select>
                                    </div>}
                                    {!i.add
                                        && this.state.modCodes?.length > i.modifiers?.length
                                        && !this.props.disabled
                                        && <span role="button" className="btn ms-md-2" onClick={() => this.toggleAddMod(i)}><Icon icon="faPlus" /></span>}
                                </td>
                                <td>
                                <span>
                                        {i.diagCodes?.length === 0 && !i.add && <span className="text-muted">None</span>}
                                        {i.diagCodes?.map((j, jdx) => (
                                            <span key={jdx} className="badge bg-secondary me-1 mb-1 no-select" title={j.description} data-tooltip-content={j.description}>
                                                {j.code} <Icon icon="faTimes" role="button" onClick={() => this.removeDiagCode(i, j)} />
                                            </span>
                                        ))}
                                    </span>
                                    {i.addDiagCode && <div className="input-group">
                                        <select className="form-select" onChange={(e) => this.addDiagCode(e, i)}>
                                            <option value="">Select Diag Code</option>
                                            {this.props.diagCodes?.map((j, jdx) => !i.diagCodes?.find(a => a.id === j.id)
                                                && <option key={jdx} value={j.id}>{j.code} - {j.description}</option>)}
                                            <option value="OTHER">Other...</option>
                                        </select>
                                    </div>}
                                    {!i.addDiagCode
                                        && this.props.diagCodes?.length > i.diagCodes?.length
                                        && !this.props.disabled
                                        && <span role="button" className="btn ms-md-2" onClick={() => this.toggleAddDiagCode(i)}><Icon icon="faPlus" /></span>}
                                </td>
                                <td>
                                    <Editable value={i.fee} currency onChange={(v) => this.applyField(i, 'fee', v)} disabled={this.props.disabled} />
                                </td>
                                <td>
                                    <Editable value={i.units} onChange={(v) => this.applyField(i, 'units', v)} disabled={this.props.disabled} />
                                </td>
                                <td>{Globals.formatCurrency(i.charge)}</td>
                                <td className="text-end">
                                    {i.units > 1 && <span role="button" title="Split" className="btn btn-secondary ms-md-2" onClick={() => this.split(i)}><Icon icon="faArrowsSplitUpAndLeft" /></span>}
                                    <span role="button" title="Delete" className="btn btn-danger ms-md-2" onClick={() => this.props.onRemove(idx)}><Icon icon="faTrash" /></span>
                                </td>
                            </tr>
                        </tbody>
                    ))}
                    <tfoot>
                        <tr>
                            <td colSpan={5}></td>
                            <td className="text-end">Total:</td>
                            <td>
                                <strong>{this.getTotalUnits()}</strong>
                            </td>
                            <td colSpan={2}>
                                <strong>{Globals.formatCurrency(this.getTotal())}</strong>
                            </td>
                        </tr>
                    </tfoot>
                </table>
                <div className="text-end mb-3">
                    <button type="button" className="btn btn-primary" onClick={() => this.props.onAdd?.()}><Icon icon="faPlus" /> Add Item</button>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <FormInput model={this.props.claim} name="priorAuthNumber" label="Prior Auth Number" placeholder="##########" onChange={this.props.onToggle} />
                    </div>
                    <div className="col-md-8">
                        <FormInput model={this.props.claim} name="message" label="Claim Message" placeholder="Message here..." onChange={this.props.onToggle} />
                    </div>
                </div>
            </Card>
            </>
        );
    }
}

export default withParamsAndNavigate(ClaimItemTable);